import { useState } from "react";
import { Search, ImageOff } from "lucide-react";
import { fmt, fmtMoney, photoUrl } from "@/lib/api";
import { Input } from "@/components/ui/input";

export const FabricGallery = ({ fabrics, stockOf, selectedId, onSelect }) => {
  const [q, setQ] = useState("");
  const list = fabrics.filter((f) => `${f.reference} ${f.name} ${f.type}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="space-y-2" data-testid="fabric-gallery">
      <div className="relative"><Search size={14} className="absolute left-3 top-3 text-muted-foreground" /><Input className="pl-8" placeholder="Rechercher un article (nom, référence, type)…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="gallery-search" /></div>
      <div className="grid max-h-72 grid-cols-3 gap-2 overflow-y-auto pr-1 sm:grid-cols-4 lg:grid-cols-5">
        {list.length === 0 && <p className="col-span-full py-6 text-center text-sm text-muted-foreground">Aucun article.</p>}
        {list.map((f) => {
          const stock = stockOf(f.id);
          const sel = selectedId === f.id;
          return (
            <button key={f.id} type="button" onClick={() => onSelect(f.id)} disabled={stock <= 0} data-testid={`gallery-item-${f.reference}`}
              className={`group relative overflow-hidden rounded-lg border bg-card text-left transition-all duration-150 hover:-translate-y-0.5 hover:shadow-md disabled:cursor-not-allowed disabled:opacity-40 ${sel ? "ring-2 ring-[#059669] border-[#059669]" : ""}`}>
              <div className="aspect-square w-full bg-muted">
                {f.photo_path ? <img src={photoUrl(f)} alt={f.name} className="h-full w-full object-cover" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center text-muted-foreground"><ImageOff size={22} /></div>}
              </div>
              <div className="p-2">
                <p className="truncate text-xs font-semibold">{f.name}</p>
                <p className="truncate text-[10px] text-muted-foreground">{f.reference}</p>
                <div className="mt-1 flex items-center justify-between text-[11px]"><span className="font-semibold text-[#059669]">{fmtMoney(f.sale_price)}/{f.unit || "m"}</span><span className={stock <= (f.min_stock || 0) ? "text-destructive" : "text-muted-foreground"}>{fmt(stock)} {f.unit || "m"}</span></div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export const FabricPreview = ({ fabric, stock }) => {
  if (!fabric) return <div className="flex h-24 items-center justify-center rounded-md border border-dashed text-xs text-muted-foreground" data-testid="fabric-preview-empty">Sélectionnez un article dans la galerie</div>;
  return (
    <div className="flex gap-3 rounded-md border bg-card p-2" data-testid="fabric-preview">
      <div className="h-24 w-24 flex-none overflow-hidden rounded-md bg-muted">{fabric.photo_path ? <img src={photoUrl(fabric)} alt={fabric.name} className="h-full w-full object-cover" /> : <div className="flex h-full w-full items-center justify-center text-muted-foreground"><ImageOff size={20} /></div>}</div>
      <div className="min-w-0 text-sm">
        <p className="font-display text-base font-semibold leading-tight">{fabric.name}</p>
        <p className="font-mono text-xs text-muted-foreground">{fabric.reference}{fabric.type && ` · ${fabric.type}`}{fabric.width_cm && ` · laize ${fabric.width_cm} cm`}</p>
        <p className="mt-1"><span className="font-semibold text-[#059669]">{fmtMoney(fabric.sale_price)}</span> / {fabric.unit || "m"}{fabric.roll_length && fabric.unit !== "rouleau" && <span className="text-muted-foreground"> · rouleau {fmt(fabric.roll_length)} m = {fmtMoney(fabric.roll_price || fabric.sale_price * fabric.roll_length)}</span>}</p>
        <p className="text-xs text-muted-foreground">Disponible : <b>{fmt(stock)} {fabric.unit || "m"}</b></p>
      </div>
    </div>
  );
};
